/**
 * 頼み方の例（コピーのボタンつき）。ホーム（pages/HomeC.tsx）とプロジェクトの概要（pages/OverviewPage.tsx）の 2 か所で使う。
 * 2026-09-30 console/core-first C2 で HomeC から切り出した。
 * WHY 部品にしたか: 概要の「次のステップ」の最初の一手も「AI エージェントに頼む」にした（MASTER-PLAN §0「コピペの文をエージェントに貼る →
 *   普段の言葉で頼む」）。例の文を画面ごとに写すと、片方だけ直って食い違う。出どころは homeFlow.ts の buildAsk ＋ i18n の
 *   home.askExample.* / home.askTemplate の 1 か所のまま（入口の Skill「start」ができたらそこだけ差し替える）
 */
import { buildAsk } from '../homeFlow';
import { useT } from '../i18n';
import { CopyButton } from './ui';

/**
 * 頼み方の例のキー（ホームの B の見出し pages/HomeAsk.tsx の例のボタンもこれを使う = 2 か所で数がずれない）。
 * 4 つで「公開 / DB に保存（ログイン付き）/ ゲームのセーブ / オンライン対戦」を 1 つずつ見せる
 * （4 つ目 = MASTER-PLAN §0「マルチプレイを 4 つ目の言葉として前に出す」founder 2026-10-02。i18n の home.askExample.4）
 */
export const ASK_EXAMPLES = ['home.askExample.1', 'home.askExample.2', 'home.askExample.3', 'home.askExample.4'] as const;

export function AskExamples() {
  const { t } = useT();
  return (
    <>
      <p className="home-ask-label">{t('home.c.examplesLabel')}</p>
      <ul className="home-examples">
        {ASK_EXAMPLES.map((k) => {
          const ask = buildAsk(t(k), t('home.askTemplate'));
          return (
            ask && (
              <li key={k}>
                <span className="home-example-text">{ask}</span>
                <CopyButton text={ask} />
              </li>
            )
          );
        })}
      </ul>
    </>
  );
}
